// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkListGridItem_link__DAdYQ","body":"LinkListGridItem_body__474fj","title":"LinkListGridItem_title__iGdBd","icon":"LinkListGridItem_icon__yzUjH"};